module.exports = __webpack_public_path__ + "media/assets/icons/circle-plus-blue-a8f1582bdec450115005ac095fc3b467.svg";